module.exports = __webpack_public_path__ + "static/media/every_day_dating.c67b7d8b.png";